export const environment = {
  production: false,
  githubClientId: 'Ov23liT3EoYUI5rlXf9x',
  githubRedirectUri: 'https://www.insightest.app/apps/gitten/auth',
  githubApiUrl: 'https://api.github.com',
  githubClientSecret: '471ca6c5d47da7c4ec330232163044d57e7bd629',
  mdxEditorUrl: 'https://www.insightest.app/apps/gitten/mdx/index.html', // 'http://localhost:3000/',
};

